export default (t) => ({
  'specifications': t('specification:specification_capitalize_plural'),
  'latest': t('latest'),
  'shared': t('shared'),
  'organization': t('components_library'),
  'creator': t('specification:specification_creator'),
  'variants': t('specification:model_variants'),
  'specification-parameters': t('administration'),
  'my-products': t('specification:my_products'),
  'calculations': t('timing:calculation_capitalize_plural'),
  'production-details': t('specification:production_details'),
  'document': t('specification:document'),
  'consumptions': t('specification:component_consumptions'),
  'dimensions': t('specification:model_dimensions_final'),
  'description': t('specification:model_description'),
  'brands': t('specification:brands'),
  'categories': t('categories'),
  'seasons': t('specification:seasons'),
  'sizes': t('specification:sizes'),
  'estimated-costs': t('specification:estimated_costs'),
  'elements': t('specification:elements'),
  'templates': t('specification:templates'),
  'shared-products': t('specification:shared_products'),
  'suppliers-base': t('specification:suppliers_base'),
  'order-operators': t('orderOperators:order_operators_capitalize'),
  'product-creator': t('specification:product_creator'),
  'timing-library': t('specification:timing_library'),
  'articles': t('timing:articles'),
  'processes': t('timing:processes'),
  'products-costs': t('specification:products_costs_details'),
  'summary': t('specification:summary'),
  'editor': t('specification:visual_editor'),
  'color-versions': t('specification:color_versions'),
  'production-quantities': t('specification:production_quantities'),
  'components': t('specification:component_capitalized_plural'),
  'component-consumptions': t('specification:component_consumptions'),
  'component-variants': t('specification:component_variants'),
  'component-costs': t('specification:components_cost'),
  'exchange-rates': t('common:exchange_rates'),
  'orders': t('common:orders'),
  'production-volume': t('orders:production_volume'),
  'order-volume': t('orders:order_volume'),
  'maintenance': t('common:maintenance'),
  'warehouse-releases': t('warehouseReleases:warehouse_releases'),
  'user-profile': t('common:user-profile'),
});
